import { IconButton } from '@mui/material'
import { MoonIcon, SunIcon } from 'lucide-react'
import React from 'react'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const ToggleTheme: React.FC = () => {
    const mode = useThemeStore(state => state.theme)
    const toggleTheme = useThemeStore(state => state.toggle)

    if (mode === 'dark') {
        document.documentElement.classList.remove('light')
        document.documentElement.classList.add('dark')
    } else {
        document.documentElement.classList.remove('dark')
        document.documentElement.classList.add('light')
    }

    return (
        <IconButton onClick={toggleTheme} title="Alternar tema">
            {mode === 'dark' ? (
                <SunIcon className="text-yellow-300" />
            ) : (
                <MoonIcon className="text-gray-300" />
            )}
        </IconButton>
    )
}

export const useThemeStore = create(
    persist<{ theme: 'dark' | 'light'; toggle: () => void }>(
        (set, get) => ({
            theme: 'light',
            toggle: () =>
                set({ theme: get().theme === 'dark' ? 'light' : 'dark' }),
        }),
        {
            name: 'theme',
        },
    ),
)
